import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint = 768) => {
	const [isMobile, setIsMobile] = useState(
		() => typeof window !== 'undefined' && window.innerWidth < breakpoint
	);

	useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
		const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
		mql.addEventListener('change', handler);
		setIsMobile(mql.matches);
		return () => mql.removeEventListener('change', handler);
	}, [breakpoint]);

	return isMobile;
};

export { useIsMobile };
